/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Grid } from '@mairistem/composants';

import Divider from './Divider';

interface GridColumnDividerProps {
  'data-testid'?: string;
}

const GridColumnDivider = (props: GridColumnDividerProps = {}) => {
  const { 'data-testid': dataTestId } = props;
  return (
    <>
      <Grid.Column mobile={16} only="mobile">
        <Divider data-testid={dataTestId && `${dataTestId}-mobile`} />
      </Grid.Column>
      <Grid.Column tablet={16} only="tablet">
        <Divider data-testid={dataTestId && `${dataTestId}-tablet`} />
      </Grid.Column>
      <Grid.Column
        computer={1}
        only="computer"
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: 0,
        }}
      >
        <Divider
          vertical
          data-testid={dataTestId && `${dataTestId}-computer`}
        />
      </Grid.Column>
    </>
  );
};

export default GridColumnDivider;
